<canvas [id]="canvasId" height="300px" class="p-4 w-full rounded-md"></canvas>